// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3HmbS","header":"MessagesList_header__2caJV","chat":"MessagesList_chat__16gE0"};